import React from "react";
import * as aor from "react-admin";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Tooltip from "@material-ui/core/Tooltip";
import TranslatedText from "./TranslatedText";
import Create from "@material-ui/icons/Create";
import AutoCompleteCompanyInput from "./AutoCompleteCompanyInput";
import myRestClient from "../common/restClient";
import tccStyles from "../common/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { POLICY_INSTALLATIONS } from "../common/rolesManagement";
import { InstallationEventStatus } from "../common/statuses";
import { getConfig } from "../common/utilities";
import { OperationType } from "../common/operationTypes";

const customer_companiesOptions = {
    resource: "customers-mappings",
    display: "name",
    label: "Azienda",
    isMulti: false
};

class CompanyTransfer extends React.Component {
    state = {
        open: false,
        customer_id: null,
        url_name: null,
        company_id: null,
        company_name: null,
        loading: false,
        operation: [],
        is_operational: null,
        has_operation_running: null,
        installationStatus: null,
        installationLocked: false,
        typeInstallationLocked: false
    };

    componentDidMount() {
        this.setState({
            company_id: this.props.record.company_id,
            customer_id: this.props.record.customer_id,
            installationStatus: this.props.record.status,
            installationLocked: this.props.record.locked,
            typeInstallationLocked: this.props.record.installation_type_locked
        });
        myRestClient("GET_ONE", "companies", {
            id: this.props.record.company_id
        }).then(
            result => {
                this.setState({
                    company_name: result.data.name
                });
            },
            error => {
                console.log(error);
            }
        );
        getConfig().then(result => {
            if (result) {
                this.setState({ portal_locked: result.portal_lock });
            }
        });

        if (this.props.record.installation_type_id) {
            const params = {
                pagination: { page: 1, perPage: 10000 },
                sort: { field: "name", order: "asc" },
                filter: {
                    installation_type_id: this.props.record.installation_type_id
                },
                filter_type: [OperationType.CompanyTransfer]
            };
            myRestClient("GET_LIST", "operations", params).then(
                result => {
                    const data = result.data.map(item => {
                        return {
                            id: item.operation_type_name,
                            name: item.operation_type_description
                        };
                    });
                    this.setState({
                        operation: data
                    });
                },
                error => {
                    return error;
                }
            );
        }
        const params = {
            filter: { export: true },
            pagination: { page: 1, perPage: 1000 },
            sort: { field: "customer_id", order: "asc" },
            id_inst: [this.props.record.id],
            infoTransfer: true
        };
        myRestClient("GET_LIST", "installations", params).then(
            result => {
                this.setState({
                    is_operational: result.data[0].is_operational,
                    has_operation_running: result.data[0].has_operation_running
                });
            },
            error => {
                return error;
            }
        );
    }

    handleClickOpen = () => {
        this.setState({ open: true, message: "" });
    };

    handleClose = () => {
        this.setState({
            open: false,
            company_id: null
        });
    };

    handleCloseSnackBar = () => {
        this.setState({ showSnackBar: false });
    };

    handleOk = () => {
        if (this.props.record.company_id === this.state.company_id) {
            this.setState({
                error: true,
                showSnackBar: true,
                message: "Selezionare un'azienda differente da quella attuale",
                loading: false
            });
        } else {
            const query = {
                id: this.props.record.id,
                data: {
                    tmp_customer_id: this.state.customer_id,
                    tmp_company_id: this.state.company_id,
                    tmp_access_url: this.state.url_name
                        ? this.state.url_name
                        : ""
                }
            };
            this.setState({
                loading: true
            });
            myRestClient("UPDATE_NO_PREV", "installations", query).then(
                result => {
                    this.setState({
                        open: false,
                        showSnackBar: true,
                        message: "Inviata richiesta aggiornamento",
                        error: false,
                        company_id: null,
                        loading: false
                    });
                },
                error => {
                    this.setState({
                        error: true,
                        showSnackBar: true,
                        message: error.message,
                        loading: false
                    });
                }
            );
        }
    };

    onCompanyChanged = value => {
        this.setState({ company_id: value, message: "" });
    };

    myCompanySelect(props) {
        props.input.value = [props.record.customer_id];
        return (
            <React.Fragment>
                <AutoCompleteCompanyInput
                    {...props}
                    onCompanyChanged={this.onCompanyChanged}
                    validate={aor.required()}
                    name="company_id"
                    component={AutoCompleteCompanyInput}
                    {...{
                        options: customer_companiesOptions,
                        lazy: false,
                        filter: { customer_id: this.state.customer_id }
                    }}
                />
                {this.renderErrorMessage()}
            </React.Fragment>
        );
    }

    renderErrorMessage() {
        return this.state.error === true ? (
            <div>
                <span style={{ color: tccStyles.colors.error }}>
                    {this.state.message === "Validation failed"
                        ? "Errore nella validazione dei parametri inseriti"
                        : this.state.message.includes(
                              "PATCH installations - AWX start lambda for Update failed installation_id"
                          )
                        ? "Errore comunicazione con il cloud"
                        : this.state.message}
                </span>
            </div>
        ) : (
            <div />
        );
    }

    render() {
        const permissions = this.props.permissions;
        return (
            <aor.FormDataConsumer>
                {({ formData }) => {
                    return formData ? (
                        <React.Fragment>
                            <aor.Labeled label="resources.companies.nameSingular">
                                <aor.ReferenceField
                                    key={formData.company_id}
                                    record={formData}
                                    resource="companies"
                                    basePath="/companies"
                                    source="company_id"
                                    reference="companies"
                                    linkType="show"
                                    allowEmpty
                                >
                                    <aor.TextField source="name" />
                                </aor.ReferenceField>
                            </aor.Labeled>
                            {permissions &&
                                permissions.includes(
                                    POLICY_INSTALLATIONS.COMPANY_MODIFY
                                ) &&
                                this.state.is_operational &&
                                !this.state.has_operation_running &&
                                this.state.operation.length > 0 &&
                                this.state.installationStatus !==
                                    InstallationEventStatus.pendingDelete &&
                                ((!this.state.installationLocked &&
                                    !this.state.portal_locked &&
                                    !this.state.typeInstallationLocked) ||
                                    this.props.isAdminRole) && (
                                    <Button
                                        style={{
                                            position: "relative",
                                            top: 24
                                        }}
                                        color="primary"
                                        target="_blank"
                                        onClick={this.handleClickOpen}
                                    >
                                        <Tooltip
                                            title={
                                                <TranslatedText
                                                    resource_name={`resources.installations.actions.company_modify`}
                                                />
                                            }
                                        >
                                            <Create />
                                        </Tooltip>
                                    </Button>
                                )}
                            <Dialog
                                style={{
                                    overflow: "visible",
                                    overflowY: "visible"
                                }}
                                disableBackdropClick
                                disableEscapeKeyDown
                                fullWidth={true}
                                maxWidth="xs"
                                open={this.state.open}
                                onClose={this.handleClose}
                            >
                                <DialogTitle id="form-dialog-title">
                                    <b>
                                        <TranslatedText
                                            resource_name={`resources.installations.actions.company_modify`}
                                        />
                                    </b>
                                </DialogTitle>
                                <DialogContent
                                    style={{
                                        overflow: "visible",
                                        overflowY: "visible"
                                    }}
                                >
                                    {this.myCompanySelect(this.props)}
                                </DialogContent>
                                <DialogActions>
                                    <div
                                        align="center"
                                        style={{
                                            visibility: this.state.loading
                                                ? "visible"
                                                : "hidden"
                                        }}
                                    >
                                        {<CircularProgress />}
                                    </div>
                                    {!this.state.loading && (
                                        <b>
                                            <Button
                                                onClick={this.handleClose}
                                                color="primary"
                                            >
                                                <TranslatedText
                                                    resource_name={
                                                        "ra.actions.cancel"
                                                    }
                                                />
                                            </Button>
                                            <Button
                                                onClick={this.handleOk}
                                                color="primary"
                                            >
                                                <TranslatedText
                                                    resource_name={
                                                        "ra.actions.ok"
                                                    }
                                                />
                                            </Button>
                                        </b>
                                    )}
                                </DialogActions>
                            </Dialog>
                        </React.Fragment>
                    ) : null;
                }}
            </aor.FormDataConsumer>
        );
    }
}

export default CompanyTransfer;



// WEBPACK FOOTER //
// ./src/components/CompanyTransfer.js